type TImageConfig = {
  imageUrl?: string;
  width?: number;
  height?: number;
  q?: number;
  fit?: 'bounds' | 'cover' | 'crop';
  canvas?: {
    width?: number;
    height?: number;
    ratio?: string;
  };
  bgColor?: string;
};

export const optimizeImage = (imageUrl: string, config: TImageConfig): string => {
  if (!imageUrl) {
    return imageUrl;
  }

  const params: Array<string> = [];

  if (config.width) {
    params.push(`width=${config.width}`);
  }

  if (config.height) {
    params.push(`height=${config.height}`);
  }

  if (config.fit) {
    params.push(`fit=${config.fit}`);
  }

  if (config.q) {
    params.push(`q=${config.q}`);
  }

  if (config.canvas) {
    if (config.canvas.ratio) {
      params.push(`canvas=${config.canvas.ratio}`);
    } else if (config.canvas.width && config.canvas.height) {
      params.push(`canvas=${config.canvas.width},${config.canvas.height}`);
    }
  }

  if (config.bgColor) {
    params.push(`bg-color=${config.bgColor}`);
  }

  return fixImageProtocol(imageUrl + (imageUrl.includes('?') ? '&' : '?') + params.join('&'));
};

export const squareCanvasImage = (imageUrl: string, width: number, bgColor = 'FFF'): string =>
  optimizeImage(imageUrl, {
    width,
    bgColor,
    canvas: {
      ratio: '1:1',
    },
  });

export const customLoaderImage = ({
  imageUrl,
  width,
  bgColor,
  q = 75,
  canvas,
}: TImageConfig): string =>
  optimizeImage(imageUrl, {
    width,
    bgColor,
    q,
    canvas,
  });

export const fixImageProtocol = (image: string): string => {
  if (!image) {
    return image;
  }

  if (image.startsWith('http:')) {
    return `${image}`.replace('http:', 'https:');
  }

  return image.startsWith('https:') ? `${image}` : `https:${image}`;
};

export const productImageLoader = ({ src, width }: { src: string; width: number }): string =>
  squareCanvasImage(src, width);

export const fitInImage = (imageUrl: string, size: number): string => {
  if (!imageUrl) {
    return imageUrl;
  }

  const separator = imageUrl.includes('?') ? '&' : '?';

  return fixImageProtocol(`${imageUrl}${separator}ims=fit-in/${size}x${size}`);
};

export const productGalleryImageLoader = ({ src, width }: { src: string; width: number }): string =>
  fitInImage(src, width);
